import moment from "moment";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";
import klineInterval from "../Params";

const DATA_COUNT = 2000;
const COLLECTION_NAME = "NS_CRP_XSEN070_DAILY_BALANCE";

interface IBalanceData {
  balance: IData[];
  requested: boolean;
  loaded: boolean;
}

const initialState: IBalanceData = {
  balance: [],
  requested: false,
  loaded: false,
};

export function loadxsen070DailyBalance(firebase: any) {
  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.Xsen070DailyBalance.requested) return;
    dispatch({
      type: SENTIMENT_ACTION.XSEN070_DAILY_BALANCE,
      payload: { requested: true, loaded: false, sentiment: [] },
    });

    firebase
      .firestore()
      .collection(`${COLLECTION_NAME}${klineInterval}`)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        var balanceData: Object[] = [];

        querySnapshot.forEach(function (doc: any) {
          const dateVal = moment
            .unix(doc.data().dateTime.seconds)
            .format("YYYY/MM/DD HH:mm");
          balanceData.push({
            name: "balance",
            balance: doc.data().balance,
            dateTime: doc.data().dateTime.toDate(),
          });
        });

        balanceData = balanceData.reverse();
        dispatch({
          type: SENTIMENT_ACTION.XSEN070_DAILY_BALANCE,
          payload: {
            balance: balanceData,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function Xsen070DailyBalance(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.XSEN070_DAILY_BALANCE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const xsen070DailyBalanceSelector = (state: any) =>
  state.Xsen070DailyBalance;
